<template>
    <router-link class="product-card" :to="{ name: 'product_info', params: { id: data.id } }">
        <div class="card border-1 border-white shadow-sm h-100 ms-sm-2 bg-danger1 bg-opacity-10">
            <div class="card-img-top" :style="`background-image: url(${data.product_images && data.product_images.length ? data.product_images[0].image : '/assets/images/noimg.png'});`"></div>
            <div class="card-body pb-3">
                <h3 class="h6 mb-2 text-site">
                    {{data.translate.length ? data.translate[0].name : data.name}}
                </h3>
                <p class="fs-7 mb-2">{{data.translate.length && data.translate[0].description ? $filters.stripTags(data.translate[0].description).split(' ').splice(0, 12).join(' ') + '...' : data.info}}</p>
            </div>
            <div class="card-footer fs-sm text-muted bg-white1 border-0">
                <p v-if="data.size" class="fs-7 mb-2 text-secondary">{{ lang?.size }}:
                    <span v-for="(sitem, sindex) in data.size" :key="sindex" class="py-1 px-2 me-1 bg-light text-dark">
                        {{ sitem }}
                    </span>
                </p>
                <p class="fs-7 fw-semibold">{{ lang?.price }}: {{ $filters.formatCurrency(data.price) }}</p>
            </div>
        </div>
    </router-link>
</template>


<script>
export default {
    name: "ProductC",
    props:{
        data: {
            type: Object,
            default: () => {}
        },
        lang: {
            type: Object,
            default: () => {}
        },
    },
    setup() {
        return {
        };
    },
}
</script>

<style lang="scss">
.product-card{
.card{
    transition-duration: .1s;
    transition-timing-function: linear;
    border-radius: 10px;
    background-color: rgba(206, 202, 202, 0.2);
}
.card:hover{
    box-shadow: 0px 0px 10px #0f0e0e !important;
    transform: scale(0.98, 0.98);
}
.card-img-top{
    border-radius: 10px;
    width: 100%;
    height: 280px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    background-color: #efefef;
    // border: 3px solid rgba(134, 131, 131, 0.1);
}

@media(max-width: 576px) {
    .card-img-top{
        height: 240px;
    }
}
}
</style>
